import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { navigationService } from 'src/config/rootService';
import { getFirstFiveMeditations } from 'src/modules/meditations/selectors/meditationSelectors';
import { useProgramsForPreview } from 'src/modules/newPrograms/hooks/usePrograms';
import { Wrapper } from 'src/shared/components/Wrapper';
import { ContentCardsRow, PageHeader, SectionHeader } from 'src/shared/ds';
import i18n from 'src/config/i18n';

export const Resources = () => {
    const { t } = useTranslation();
    const programs = useProgramsForPreview();
    const meditations = useSelector(getFirstFiveMeditations);

    return (
        <Wrapper>
            <PageHeader>Resources</PageHeader>
            <SectionHeader
                title={t('shared:header.programs')}
                secondaryText={'View All'}
                onSecondaryTextPress={() => navigationService.navigate('/programs')}
            />
            <ContentCardsRow
                items={programs.map(program => ({
                    id: program.uuid,
                    title: program.name,
                    description: i18n.t(`dashboard:program.duration`, {
                        duration: program.duration ?? 1,
                    }),
                    image: program.image ?? '',
                    onClick: () => navigationService.navigate(`/program/${program.slug}`),
                    backgroundColor: 'white',
                }))}
            />
            <SectionHeader
                title={t('shared:header.meditations')}
                secondaryText={'View All'}
                onSecondaryTextPress={() => navigationService.navigate('/programs')}
            />
            <ContentCardsRow
                items={meditations.map(meditation => ({
                    id: meditation.uuid,
                    title: meditation.name,
                    description: i18n.t(`dashboard:meditation.duration`, {
                        duration: meditation.duration ?? 1,
                    }),
                    image: meditation.image ?? '',
                    onClick: () => navigationService.navigate(`/meditations/${meditation.slug}`),
                    backgroundColor: 'white',
                }))}
            />
        </Wrapper>
    );
};
